import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user ? user.user.roles[0] : null;
  console.log("🚀 ~ Navdata ~ user:", user?.user?.roles);
  console.log("🚀 ~ role:", role);

  // State for toggling submenus
  const [isSalesOrders, setIsSalesOrders] = useState(false);
  const [isManagement, setIsManagement] = useState(false);
  const [isReports, setIsReports] = useState(false);
  const [isSalesReports, setIsSalesReports] = useState(false);
  const [isPrimarySetup, setIsPrimarySetup] = useState(false);
  const [isExpenseSetup, setIsExpenseSetup] = useState(false);
  const [isSupplierMenu, setIsSupplierMenu] = useState(false);
  const [isSettings, setIsSettings] = useState(false);
  const [isCurrentState, setIsCurrentState] = useState(
    role === "BillingUser" ? "organization-sales" : "Dashboard"
  );

  const updateIconSidebar = (e) => {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      iconItems.forEach((item) => {
        item.classList.remove("active");
        const id = item.getAttribute("subitems");
        if (document.getElementById(id)) {
          document.getElementById(id).classList.remove("show");
        }
      });
    }
  };

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },

    // ========== DASHBOARD ==========
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: role === "SuperAdmin" ? "/dashboard" : "/org-dashboard",
      parentId: "management",
      click: (e) => {
        e.preventDefault();
        setIsCurrentState("Dashboard");
        const targetPath =
          role === "SuperAdmin" ? "/dashboard" : "/org-dashboard";
        console.log(`Navigating to ${targetPath}`);
        navigate(targetPath);
      },
    },
    {
      id: "organization-sales",
      label: "Organization Sales",
      icon: "ri-currency-line",
      link: "/organization-pos",
      parentId: "sales-orders",
      click: (e) => {
        e.preventDefault();
        setIsCurrentState("organization-sales");
        navigate("/organization-pos");
      },
    },
    // ========== SALES & ORDERS GROUP ==========
    {
      id: "sales-orders",
      label: "Sales & Orders",
      icon: "ri-currency-line",
      link: "/#",
      click: (e) => {
        e.preventDefault();
        setIsSalesOrders(!isSalesOrders);
        setIsCurrentState("sales-orders");
        updateIconSidebar(e);
      },
      stateVariables: isSalesOrders,
      subItems: [
        // ...(role === "BillingUser" || role === "Waiter"
        //   ? [
        //       {
        //         id: "organization-sales",
        //         label: "Organization Sales",
        //         icon: "ri-currency-line",
        //         link: "/organization-pos",
        //         parentId: "sales-orders",
        //         click: (e) => {
        //           e.preventDefault();
        //           setIsCurrentState("organization-sales");
        //           navigate("/organization-pos");
        //         },
        //       },
        //     ]
        //   : []),

        {
          id: "organization-sales-mobile",
          label: "Waiter Order",
          icon: "ri-currency-line",
          link: "/organization-pos-mobile",
          parentId: "sales-orders",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("organization-sales-mobile");
            navigate("/organization-pos-mobile");
          },
        },
        {
          id: "organization-order-token",
          label: "Organization Token",
          icon: "ri-currency-line",
          link: "/order-token",
          parentId: "sales-orders",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("organization-order-token");
            navigate("/order-token");
          },
        },
        {
          id: "order-management",
          label: "Order Management",
          icon: "ri-apps-2-line",
          link: "/order-management",
          parentId: "sales-orders",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("order-management");
            navigate("/order-management");
          },
        },
        {
          id: "complimentry-logs",
          label: "Complimentary Logs",
          icon: "ri-apps-2-line",
          link: "/complimentry-logs",
          parentId: "sales-orders",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("complimentry-logs");
            navigate("/complimentry-logs");
          },
        },
      ],
    },

    // ========== PURCHASES & SUPPLIERS GROUP ==========
    {
      id: "supplier-menu",
      label: "Purchases & Suppliers",
      icon: "ri-shopping-cart-line",
      link: "/#",
      click: (e) => {
        e.preventDefault();
        setIsSupplierMenu(!isSupplierMenu);
        setIsCurrentState("supplier-menu");
        updateIconSidebar(e);
      },
      stateVariables: isSupplierMenu,
      subItems: [
        {
          id: "purchase",
          label: "Purchase",
          icon: "ri-shopping-cart-line",
          link: "/purchase",
          parentId: "supplier-menu",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("purchase");
            navigate("/purchase");
          },
        },
        {
          id: "supplier",
          label: "Supplier",
          icon: "ri-user-2-line",
          link: "/supplier",
          parentId: "supplier-menu",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("supplier");
            navigate("/supplier");
          },
        },
        {
          id: "supplierPaymentLog",
          label: "Supplier Payment Log",
          icon: "ri-money-dollar-circle-line",
          link: "/supplier-payment-log",
          parentId: "supplier-menu",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("supplierPaymentLog");
            navigate("/supplier-payment-log");
          },
        },
      ],
    },

    // ========== MENU SETUP GROUP ==========
    ...(role === "SuperAdmin" || role === "GeneralAdmin"
      ? [
          {
            id: "primarySetup",
            label: "Menu Setup",
            icon: "ri-restaurant-line",
            link: "/#",
            parentId: "management",
            click: (e) => {
              e.preventDefault();
              setIsPrimarySetup(!isPrimarySetup);
              setIsCurrentState("primarySetup");
              updateIconSidebar(e);
            },
            stateVariables: isPrimarySetup,
            subItems: [
              {
                id: "table-management",
                label: "Table Management",
                icon: "ri-table-line",
                link: "/table-management",
                parentId: "primarySetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("table-management");
                  navigate("/table-management");
                },
              },
              {
                id: "menu-category",
                label: "Menu Category",
                icon: "ri-list-check",
                link: "/menu-category",
                parentId: "primarySetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("menu-category");
                  navigate("/menu-category");
                },
              },
              {
                id: "menu-item",
                label: "Menu Item",
                icon: "ri-file-list-line",
                link: "/menu-item",
                parentId: "primarySetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("menu-item");
                  navigate("/menu-item");
                },
              },
              {
                id: "menu-image",
                label: "Menu Image",
                icon: "ri-image-line",
                link: "/menu-image",
                parentId: "primarySetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("menu-image");
                  navigate("/menu-image");
                },
              },
              {
                id: "discount",
                label: "Discount Offers",
                icon: "ri-percent-line",
                link: "/discount-offer",
                parentId: "primarySetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("discount");
                  navigate("/discount-offer");
                },
              },
            ],
          },
        ]
      : []),

    // ========== EXPENSES GROUP ==========
    ...(role === "SuperAdmin" || role === "GeneralAdmin"
      ? [
          {
            id: "expenseSetup",
            label: "Expenses",
            icon: "ri-money-dollar-box-line",
            link: "/#",
            click: (e) => {
              e.preventDefault();
              setIsExpenseSetup(!isExpenseSetup);
              setIsCurrentState("expenseSetup");
              updateIconSidebar(e);
            },
            stateVariables: isExpenseSetup,
            subItems: [
              {
                id: "category",
                label: "Expense Category",
                icon: "ri-folder-line",
                link: "/expense-category",
                parentId: "expenseSetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("category");
                  navigate("/expense-category");
                },
              },
              {
                id: "expense-heading",
                label: "Expense Heading",
                icon: "ri-heading",
                link: "/expense-heading",
                parentId: "expenseSetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("expense-heading");
                  navigate("/expense-heading");
                },
              },
              {
                id: "expense-detail",
                label: "Expense Detail",
                icon: "ri-file-text-line",
                link: "/expense-detail",
                parentId: "expenseSetup",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("expense-detail");
                  navigate("/expense-detail");
                },
              },
            ],
          },
        ]
      : []),

    // ========== FINANCIAL MANAGEMENT GROUP ==========
    {
      id: "bank",
      label: "Bank",
      icon: "ri-bank-line",
      link: "/bank",
      click: (e) => {
        e.preventDefault();
        setIsCurrentState("bank");
        navigate("/bank");
      },
    },

    // ========== REPORTS GROUP ==========
    {
      id: "report-sales",
      label: "Sales Reports",
      icon: "ri-bar-chart-line",
      link: "/#",
      parentId: "reports",
      click: (e) => {
        e.preventDefault();
        setIsSalesReports(!isSalesReports);
        setIsCurrentState("report-sales");
        updateIconSidebar(e);
      },
      stateVariables: isSalesReports,
      subItems: [
        {
          id: "report-sales",
          label: "Sales Report",
          icon: "ri-line-chart-line",
          link: "/report-sales",
          parentId: "report-sales",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("report-sales");
            navigate("/report-sales");
          },
        },
        {
          id: "report-sales-categorywise",
          label: "Categorywise Report",
          icon: "ri-pie-chart-line",
          link: "/report-sales-categorywise",
          parentId: "report-sales",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("report-sales-categorywise");
            navigate("/report-sales-categorywise");
          },
        },
        {
          id: "report-sales-itemwise",
          label: "Itemwise Report",
          icon: "ri-bar-chart-grouped-line",
          link: "/report-sales-itemwise",
          parentId: "report-sales",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("report-sales-itemwise");
            navigate("/report-sales-itemwise");
          },
        },
      ],
    },

    {
      id: "reports",
      label: "Business Reports",
      icon: "ri-file-chart-line",
      link: "/#",
      click: (e) => {
        e.preventDefault();
        setIsReports(!isReports);
        setIsCurrentState("reports");
        updateIconSidebar(e);
      },
      stateVariables: isReports,
      subItems: [
        ...(role === "SuperAdmin" || role === "GeneralAdmin"
          ? [
              {
                id: "sales-summary",
                label: "Stock Summary",
                icon: "ri-stack-line",
                link: "/stock-summary",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("sales-summary");
                  navigate("/stock-summary");
                },
              },
              {
                id: "sales",
                label: "Sales",
                icon: "ri-shopping-bag-line",
                link: "/sales-report",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("sales");
                  navigate("/sales-report");
                },
              },
              {
                id: "supplierPurchased",
                label: "Supplier Performance",
                icon: "ri-user-star-line",
                link: "/supplier-purchased-report",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("supplierPurchased");
                  navigate("/supplier-purchased-report");
                },
              },
              {
                id: "supplierPurchasedItems",
                label: "ItemWise Report",
                icon: "ri-file-list-3-line",
                link: "/supplier-purchased-items",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("supplierPurchasedItems");
                  navigate("/supplier-purchased-items");
                },
              },
              {
                id: "bankStatement",
                label: "Bank Statement",
                icon: "ri-bank-card-line",
                link: "/bank-statement",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("bankStatement");
                  navigate("/bank-statement");
                },
              },
              {
                id: "counterCashTransaction",
                label: "Counter Cash Transaction",
                icon: "ri-money-dollar-circle-line",
                link: "/counter-cash-transaction",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("counterCashTransaction");
                  navigate("/counter-cash-transaction");
                },
              },
              {
                id: "creditList",
                label: "Credit List",
                icon: "ri-bank-card-2-line",
                link: "/credit-list",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("creditList");
                  navigate("/credit-list");
                },
              },
              {
                id: "daybook",
                label: "Daybook",
                icon: "ri-book-open-line",
                link: "/daybook",
                parentId: "reports",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("daybook");
                  navigate("/daybook");
                },
              },
            ]
          : []),
      ],
    },

    // ========== USER & ORGANIZATION MANAGEMENT GROUP ==========
    {
      id: "management",
      label: "User Management",
      icon: "ri-team-line",
      link: "/#",
      click: (e) => {
        e.preventDefault();
        setIsManagement(!isManagement);
        setIsCurrentState("management");
        updateIconSidebar(e);
      },
      stateVariables: isManagement,
      subItems: [
        ...(role !== "SuperAdmin"
          ? [
              {
                id: "update-profile",
                label: "Update Profile",
                icon: "ri-user-settings-line",
                link: "/update-profile",
                parentId: "management",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("update-profile");
                  navigate("/update-profile");
                },
              },
            ]
          : []),
        ...(role === "GeneralAdmin"
          ? [
              {
                id: "general_crud",
                label: "User Management",
                icon: "ri-group-line",
                link: "/list-users-general-admin",
                parentId: "management",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("general_crud");
                  navigate("/list-users-general-admin");
                },
              },
            ]
          : []),
        {
          id: "organization-user",
          label: "Org User",
          icon: "ri-user-3-line",
          link: "/organization-user",
          parentId: "management",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("organization-user");
            navigate("/organization-user");
          },
        },
        {
          id: "customer",
          label: "Customer",
          icon: "ri-user-heart-line",
          link: "/customer",
          parentId: "management",
          click: (e) => {
            e.preventDefault();
            setIsCurrentState("customer");
            navigate("/customer");
          },
        },
        ...(role === "SuperAdmin"
          ? [
              {
                id: "OrganizationManagement",
                label: "Org Management",
                icon: "ri-building-line",
                link: "/organization-management",
                parentId: "management",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("OrganizationManagement");
                  navigate("/organization-management");
                },
              },
              {
                id: "tenant",
                label: "Tenant",
                icon: "ri-community-line",
                link: "/tenant",
                parentId: "management",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("tenant");
                  navigate("/tenant");
                },
              },
            ]
          : []),
      ],
    },

    // ========== COMMUNICATION ==========
    {
      id: "contact-message",
      label: "Contact Messages",
      icon: "ri-message-3-line",
      link: "/contact-message",
      click: (e) => {
        e.preventDefault();
        setIsCurrentState("contact-message");
        navigate("/contact-message");
      },
    },

    // ========== SETTINGS GROUP (SuperAdmin Only) ==========
    ...(role === "SuperAdmin"
      ? [
          {
            id: "Settings",
            label: "Settings",
            icon: "ri-settings-3-line",
            link: "/#",
            click: (e) => {
              e.preventDefault();
              setIsSettings(!isSettings);
              setIsCurrentState("Settings");
              updateIconSidebar(e);
            },
            stateVariables: isSettings,
            subItems: [
              {
                id: "general-settings",
                label: "General Settings",
                icon: "ri-settings-5-line",
                link: "/settings/general-settings",
                parentId: "Settings",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("general-settings");
                  navigate("/settings/general-settings");
                },
              },
              {
                id: "view-profile",
                label: "View Profile",
                icon: "ri-user-line",
                link: "/view-profile",
                parentId: "Settings",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("view-profile");
                  navigate("/view-profile");
                },
              },
              {
                id: "theme",
                label: "Theme",
                icon: "ri-palette-line",
                link: "/theme",
                parentId: "Settings",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("theme");
                  navigate("/theme");
                },
              },
              {
                id: "theme-option",
                label: "Theme Options",
                icon: "ri-brush-line",
                link: "/theme-option",
                parentId: "Settings",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("theme-option");
                  navigate("/theme-option");
                },
              },
              {
                id: "currency",
                label: "Currency",
                icon: "ri-money-dollar-circle-line",
                link: "/currency",
                parentId: "Settings",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("currency");
                  navigate("/currency");
                },
              },
              {
                id: "unit",
                label: "Unit",
                icon: "ri-ruler-line",
                link: "/unit",
                parentId: "Settings",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("unit");
                  navigate("/unit");
                },
              },
              {
                id: "organization-sitemap",
                label: "Organization Sitemap",
                icon: "ri-map-pin-line",
                link: "/sitemap",
                parentId: "Settings",
                click: (e) => {
                  e.preventDefault();
                  setIsCurrentState("organization-sitemap");
                  navigate("/sitemap");
                },
              },
            ],
          },
        ]
      : []),
  ];

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
